import React from "react";
import { useTranslation } from "react-i18next";
import { baseContainer, LoginStatus } from "@base-provider";
import SFDialog from "../dialog";

const TenantChangeConfirmation = ({ open, onClose }) => {
  if (!open) return null;
  const { t } = useTranslation();

  return (
    <SFDialog
      variant="default"
      title={t("components.switchTenantDialog.header")}
      message={t("components.switchTenantDialog.bodyText")}
      open={open}
      onClose={() => onClose(false)}
      primaryButton
      primaryButtonProps={{
        onClick: () => {
          onClose(false);
          //re-fresh user tenants first then change to tenant selection screen
          baseContainer.authenticationService
            .getTenants(true)
            .then((r) =>
              baseContainer.authenticationService.changeStatus(
                LoginStatus.TenantSelection
              )
            );
        },
      }}
      secondaryButton
      secondaryButtonProps={{
        onClick: () => onClose(false),
      }}
    />
  );
};

export default TenantChangeConfirmation;
